{
  "title": "国际化示例",
  "password": "密码",
  "job": "工作",
  "default_timezone": "默认当前用户设备时区",
  "time_range": "时间范围:",
  "front_end_engineer": "前端工程师",
  "back_end_engineer": "后端工程师",
  "responsive_title": "响应式示例",
  "responsive_hint": "拖拽浏览器窗口宽度，当前断点会自动高亮（纯 CSS 实现，无 JS）",
  "responsive_section_indicator": "当前断点",
  "responsive_section_grid": "响应式布局示例",
  "responsive_grid_hint": "Mobile 侧边栏横铺 + 1 列卡片 → Pad 侧边栏折叠 + 2 列卡片 → PC 侧边栏展开 + 3 列卡片",
  "responsive_sidebar": "侧边栏",
  "responsive_card_n": "卡片 {{n}}",
  "responsive_section_reference": "使用示例"
}
